module.exports = __webpack_public_path__ + "static/media/onboarding.880c423c.svg";